import { render, staticRenderFns } from "./ExportarBpa.vue?vue&type=template&id=db0a0dba"
import script from "./ExportarBpa.vue?vue&type=script&lang=js"
export * from "./ExportarBpa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports